<template>
	<div class="navbar-header">
		<a class="navbar-brand" href="index.html">Onestore.io</a>
	</div>
</template>


<script>
export default {
  name: "app-header-title",
  data() {
    return {};
  },
  methods: {}
};
</script>


// WEBPACK FOOTER //
// src/components/common/AppHeaderTitle.vue